// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.
import { AsYouType } from "libphonenumber-js";
import { Question } from "./QuestionnaireTypes";
import { capitalize } from "lodash";
import diff from "fast-diff";

export const zipCodeFormatter = (code: string) => {
  return code.replace(/[^0-9()-]/g, "");
};

export const onlyNumberFormatter = (input: string) => {
  return input.replace(/[^0-9]/gi, "");
};

let regFindPhoneSpecialChars: RegExp | undefined;

export const phoneNumberFormatter = (
  input: string,
  questions: { [key: string]: Question },
  currentQuestion: Question
) => {
  const currentValue = currentQuestion.value;

  // No need to reformat on deletion if the character deleted is a special
  // phone character: '(', ')', '-' or ' '.
  // If we don't do this, it's impossible to delete those as they get added again
  // by the formatter.
  if (currentValue && input.length < currentValue.length) {
    const diffResult = diff(currentValue, input);
    if (
      regFindPhoneSpecialChars === undefined ||
      regFindPhoneSpecialChars === null
    ) {
      regFindPhoneSpecialChars = /([-()\s])/g;
    }
    if (
      diffResult.some(diffDetail => {
        if (regFindPhoneSpecialChars && diffDetail[0] === diff.DELETE) {
          const match = diffDetail[1].match(regFindPhoneSpecialChars);
          return match && match.length > 0;
        }
        return false;
      })
    ) {
      return input;
    }
  }

  return new AsYouType("US").input(input);
};

export const capitalizeWords = (input: string) => {
  const endsWithSpace = input[input.length - 1] === " ";
  const capitalized = input
    .split(" ")
    .filter(word => word.length > 0)
    .map(word => capitalize(word))
    .join(" ");
  return capitalized + (endsWithSpace ? " " : "");
};
